export default __webpack_public_path__ + "static/magneto-logo-a0608289635e70bc10f591e741d526b7.webp";